export default "<iframe frameBorder=\"0\" class=\"e2e-iframe-untrusted-src iframe\" [src]=\"srcIframe\"></iframe>\n\n"